import React from "react"
import PostCard from "./PostCard"
import { Block } from "baseui/block"

const gap = 6
const gapTablet = 6
const gapMobile = 6

const fullGap = ["0px", `${gapTablet}px`, `${gap}px`, `${gap}px`]

const containerGap = [
  `0px`,
  `${gapTablet / 2}px`,
  `${gap / 2}px`,
  `${gap / 2}px`,
]

const CardLayout1 = ({ post }: any) => (
  <Block
    height={"100%"}
    width={["100%", "50%", "50%", "50%"]}
    paddingLeft={containerGap}
    paddingRight={containerGap}
    marginBottom={[`${gapMobile}px`, "0px", "0px", "0px"]}
  >
    <PostCard post={post} />
  </Block>
)

const CardLayout2 = ({ post, padLeft, padRight }: any) => (
  <Block
    height={"100%"}
    width={["50%", "50%", "50%", "50%"]}
    paddingLeft={
      padLeft
        ? [
            `${gapMobile / 2}px`,
            `${gapTablet / 2}px`,
            `${gap / 2}px`,
            `${gap / 2}px`,
          ]
        : "0px"
    }
    paddingRight={
      padRight
        ? [
            `${gapMobile / 2}px`,
            `${gapTablet / 2}px`,
            `${gap / 2}px`,
            `${gap / 2}px`,
          ]
        : "0px"
    }
    marginBottom={[`${gapMobile}px`, "0px", "0px", "0px"]}
  >
    <PostCard post={post} fullHeight />
  </Block>
)

const HorizontalRender = ({ posts }: any) => {
  return (
    <Block
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
      width={["100%", "50%", "50%", "50%"]}
      paddingLeft={containerGap}
      paddingRight={containerGap}
    >
      {posts.map((post: any) => (
        <Block
          key={post.id}
          paddingBottom={[
            `${gapMobile}px`,
            `${gapTablet}px`,
            `${gap}px`,
            `${gap}px`,
          ]}
        >
          <PostCard post={post} horizontal />
        </Block>
      ))}
    </Block>
  )
}

const renderDouble = (postData: any) => {
  return (
    <Block
      display={"flex"}
      width={"100%"}
      margin={"auto"}
      flexDirection={["column", "row", "row", "row"]}
    >
      {postData.map((post: any) => (
        <CardLayout1 key={post.id} post={post} />
      ))}
    </Block>
  )
}

const renderTriple = (postData: any) => {
  return (
    <Block
      display={"flex"}
      width={"100%"}
      margin={"auto"}
      flexDirection={["column", "row", "row", "row"]}
    >
      <CardLayout1 key={postData[0].id} post={postData[0]} />
      <Block
        display={"flex"}
        height={"100%"}
        width={["100%", "50%", "50%", "50%"]}
        paddingLeft={containerGap}
        paddingRight={containerGap}
      >
        {postData.slice(1, 3).map((post: any, index: number) => (
          <CardLayout2
            key={post.id}
            post={post}
            padLeft={index === 1}
            padRight={index === 0}
          />
        ))}
      </Block>
    </Block>
  )
}

const renderForth = (postData: any) => {
  return (
    <Block
      display={"flex"}
      width={"100%"}
      margin={"auto"}
      flexDirection={["column", "row", "row", "row"]}
    >
      <Block
        display={"flex"}
        height={"100%"}
        width={["100%", "50%", "50%", "50%"]}
        paddingLeft={containerGap}
        paddingRight={containerGap}
      >
        {postData.slice(0, 2).map((post: any, index: number) => (
          <CardLayout2
            key={post.id}
            post={post}
            padLeft={index === 1}
            padRight={index === 0}
          />
        ))}
      </Block>
      <Block
        display={"flex"}
        height={"100%"}
        width={["100%", "50%", "50%", "50%"]}
        paddingLeft={containerGap}
        paddingRight={containerGap}
      >
        {postData.slice(2, 4).map((post: any, index: number) => (
          <CardLayout2
            key={post.id}
            post={post}
            padLeft={index === 1}
            padRight={index === 0}
          />
        ))}
      </Block>
    </Block>
  )
}

const AllPostStyle = ({ posts }: any) => {
  return (
    <Block
      display={"flex"}
      width={"100%"}
      margin={"auto"}
      flexDirection={"row"}
      flexWrap={true}
    >
      {posts.map((post: any) => (
        <Block
          key={post.id}
          display={"flex"}
          height={"100%"}
          width={["100%", "33.33%", "33.33%", "33.33%"]}
        >
          <Block
            width={"100%"}
            paddingLeft={"3px"}
            paddingRight={"3px"}
            marginBottom={"6px"}
          >
            <PostCard post={post} />
          </Block>
        </Block>
      ))}
    </Block>
  )
}

const PostCollection = ({ posts, allPostStyle = false }: any) => {
  const renderCard = () => {
    if (posts.length === 1) {
      return (
        <>
          <Block display={["none", "none", "block", "block"]}>
            <PostCard post={posts[0]} horizontal showOne />
          </Block>
          <Block display={["block", "block", "none", "none"]}>
            <PostCard post={posts[0]} />
          </Block>
        </>
      )
    } else if (posts.length === 2) {
      return renderDouble(posts)
    } else if (posts.length === 3) {
      return renderTriple(posts)
    } else if (posts.length === 4) {
      return (
        <Block
          display={"flex"}
          width={"100%"}
          margin={"auto"}
          flexDirection={["column", "row", "row", "row"]}
        >
          <CardLayout1 post={posts[0]} />
          <Block
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            width={["100%", "50%", "50%", "50%"]}
            paddingLeft={containerGap}
            paddingRight={containerGap}
          >
            {posts.slice(1).map((post: any, index: number) => (
              <PostCard
                key={post.id}
                post={post}
                horizontal
                inBlock
                marginBottom={
                  index !== 2
                    ? [
                        `${gapMobile / 2}px`,
                        `${gapTablet / 2}px`,
                        `${gap / 2}px`,
                        `${gap / 2}px`,
                      ]
                    : "0px"
                }
                marginTop={
                  index !== 0
                    ? [
                        `${gapMobile / 2}px`,
                        `${gapTablet / 2}px`,
                        `${gap / 2}px`,
                        `${gap / 2}px`,
                      ]
                    : "0px"
                }
              />
            ))}
          </Block>
        </Block>
      )
    } else if (posts.length === 5) {
      return (
        <>
          {renderDouble(posts.slice(0, 2))}
          <Block height={fullGap} />
          {renderTriple(posts.slice(2, 5))}
        </>
      )
    } else if (posts.length === 6) {
      return (
        <>
          {renderDouble(posts.slice(0, 2))}
          <Block height={fullGap} />
          {renderForth(posts.slice(2, 6))}
        </>
      )
    } else if (posts.length === 7) {
      return (
        <>
          {renderTriple(posts.slice(0, 3))}
          <Block height={fullGap} />
          {renderForth(posts.slice(3, 7))}
        </>
      )
    } else if (posts.length > 7) {
      if (posts.length % 2 === 0) {
        const postSlice = posts.length / 2 + 1
        return (
          <>
            {renderDouble(posts.slice(0, 2))}
            <Block height={fullGap} />
            <Block
              display={"flex"}
              width={"100%"}
              margin={"auto"}
              flexDirection={["column", "row", "row", "row"]}
            >
              <HorizontalRender posts={posts.slice(2, postSlice)} />
              <HorizontalRender posts={posts.slice(postSlice, posts.length)} />
            </Block>
          </>
        )
      } else {
        const postSlice = posts.length / 2 + 2
        return (
          <>
            {renderTriple(posts.slice(0, 3))}
            <Block height={fullGap} />
            <Block
              display={"flex"}
              width={"100%"}
              margin={"auto"}
              flexDirection={["column", "row", "row", "row"]}
            >
              <HorizontalRender posts={posts.slice(3, postSlice)} />
              <HorizontalRender posts={posts.slice(postSlice, posts.length)} />
            </Block>
          </>
        )
      }
    }
  }

  return allPostStyle ? <AllPostStyle posts={posts} /> : renderCard()
}

export default PostCollection
